module.exports = __webpack_public_path__ + "media/images/pages/ic-menu-lines-05e5d869655f81dca6aee193ec165d0a.png";